import React from 'react'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import useEntityById from '../../io/useEntityById'
import useEntityTypes from '../../io/useEntityTypes'
import EntityFieldDisplayRow from './EntityFieldDisplayRow'
import EntityReferenceValue from './EntityReferenceValue'
import Field = com.eidu.entity.field.Field
import entityIdFromStringOrNull = com.eidu.entity.entityIdFromStringOrNull

export type EntityFormReferenceDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormReferenceDisplay = ({ field, fieldValue }: EntityFormReferenceDisplayProps) => {
  const selectedId = fieldValue?.value?.let((it) => entityIdFromStringOrNull(it)) ?? undefined
  const { entity: selected, loading } = useEntityById(selectedId)
  const { entityTypes } = useEntityTypes()
  const typeName = selected?.let((it) => entityTypes?.get(it.entity.typeId)?.name)
  return (
    <EntityFieldDisplayRow field={field}>
      {selectedId && <EntityReferenceValue id={selectedId} entity={selected} typeName={typeName} loading={loading} />}
    </EntityFieldDisplayRow>
  )
}

export default EntityFormReferenceDisplay
